<template>

    <!--<div class="tiny footer" layout="column bottom-left">-->

    <!--<div layout="column bottom-left">-->
    <!--<div class="contact-form">-->
    <!--<p><input v-model="name"/></p>-->
    <!--<p><input v-model="email"/></p>-->
    <!--<p><textarea v-model="message"/></p>-->
    <!--</div>-->
    <!--<a href="mailto:me@bjoernacker.de?body=Hello Björn!">Say Hello!</a>-->
    <!--</div>-->
    <!--<div self="right"> © 2018 Bj&ouml;rn Acker //-->
    <!--<router-link to="/legalnotice"><span style="font-weight: 100">Legal Notice</span></router-link>-->
    <!--</div>-->
    <!--</div>-->

    <div class="footer" layout="column top-left">
        <!--<transition name="fade">-->

        <div v-show="formVisible" ref="form" class="contact-form-wrapper">
            <div layout="row stretch-stretch" class="contact-form">
                <div class="close" @click="hideForm()"><img src="@/assets/close.svg"/></div>
                <div>
                    <input v-model="form.name" placeholder="Name"/>
                    <input v-model="form.email" placeholder="E-Mail"/>
                    <textarea placeholder="Message" v-model="form.message"/>
                    <button :disabled="!formIsValid" @click="send()">Send</button>
                </div>
            </div>
        </div>
        <!--</transition>-->
        <div class="tiny" layout="row bottom-left">
            <transition name="fade">
                <div v-if="!formVisible">
                    <span class="link" v-if="!thanks" @click="showForm()">Say Hello!</span>
                    <span v-if="thanks" @click="showForm()">Thanks!</span>
                </div>
            </transition>
            <div self="right"> © 2018 Bj&ouml;rn Acker //
                <router-link to="/legalnotice"><span style="font-weight: 100">Legal Notice</span></router-link>
            </div>
        </div>
    </div>

</template>

<script>
    import {TweenMax, Sine} from 'gsap';
    import axios from 'axios';

    export default {
        name: "the-footer",
        computed: {
            formIsValid: function () {
                // return true;
                if (this.form.email === '' || this.form.name === '' || this.form.message === '') return false;
                const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(this.form.email).toLowerCase());
            }
        },
        methods: {
            showForm() {
                this.formVisible = true;
                this.$refs.form.style.height = 0;
                TweenMax.to(this.$refs.form, 0.2,
                    {
                        height: '27rem',
                        ease: Sine.easeOut,
                        onUpdate: () => {
                            window.scrollTo(0, document.body.scrollHeight);
                        }
                    });

            },
            hideForm(callback) {
                // this.$refs.form.style.height = 0;
                TweenMax.to(this.$refs.form, 0.2,
                    {
                        height: '0',
                        ease: Sine.easeIn,
                        onUpdate: () => {
                            window.scrollTo(0, document.body.scrollHeight);
                        },
                        onComplete: () => {
                            this.formVisible = false;
                            if (callback) callback();
                        }
                    });
            },
            send() {
                //

                // let axiosConfig = {
                //     headers: {
                //         'Content-Type': 'application/json;charset=UTF-8',
                //         "Access-Control-Allow-Origin": "*",
                //     }
                // };

                console.log(this.form);
                axios.post(`https://api.bjoernacker.de/sayhello`, this.form)
                // axios.post('http://localhost:12500/sayhello', this.form)
                    .then((response) => {
                        console.log(response);
                    })
                    .catch((err) => {
                    });

                this.hideForm(()=>{
                    this.form.email = this.form.name = this.form.message = '';
                    this.thanks = true;
                    setTimeout(()=>{
                        this.thanks = false;
                    }, 3000);
                })
            }
        },
        data() {
            return {
                form: {
                    name: '',
                    email: '',
                    message: ''
                },
                sayLabel: 'Say Hello!',
                formVisible: false,
                thanks:false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .footer {
        margin-top: 3rem;
        margin-bottom: 1rem;
    }

    .tiny {
        font-size: 0.8rem;
    }

    $back: #282828;

    input, textarea, button {
        padding: 1rem;
        border: solid 1px #9c9c9c;
        background-color: $back;
        width: 100%;
        color: white;
        font-weight: 500;
        margin-bottom: 0.5rem;

    }

    input:focus, textarea:focus, button:focus {
        outline: 2px white solid;
    }

    button {
        width: 10rem;
        /*border: none;*/
        /*background-color: black;*/
    }

    button:disabled {
        opacity: 0.3;
    }

    textarea {
        height: 10rem;
        resize: none;
    }

    .close {
        position: absolute;
        top: 0.7rem;
        right: 0.7rem;
        cursor: pointer;

        img {
            width: 1.5rem;
        }

    }

    .contact-form-wrapper {
        /*style="width:50%;min-width:height:0rem; overflow: hidden;"*/
        width: 50%;
        height: 27rem;
        overflow: hidden;
        @media screen and (max-width: 1025px) {
            width: 100%;
        }
    }

    .contact-form {
        position: relative;
        width: 100%;
        min-height: 8rem;
        background-color: $back;
        color: white;
        padding: 3rem;
        /*padding-left: 2rem;*/
        /*padding-right: 1rem;*/
        /*padding-bottom: 1rem;*/
        margin-bottom: 0.5rem;
        overflow: hidden;

    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }


</style>
